import React from 'react';
import { Box, useTheme, Divider } from '@mui/material';
import { Button, Typography } from '@fdha/web-ui-library';

import { getStyles } from './ChooseMealsFooter.styles';

interface ChooseMealsFooterProps {
  entreesSelected: number;
  entreesTotal: number;
  snacksSelected: number;
  snacksTotal: number;
  handleReviewSelection: () => void;
}

const ChooseMealsFooter: React.FC<ChooseMealsFooterProps> = ({
  entreesSelected,
  entreesTotal,
  snacksSelected,
  snacksTotal,
  handleReviewSelection,
}) => {
  const theme = useTheme();
  const styles = getStyles(theme);

  const entreesLabel = 'Entree Dishes';
  const snacksLabel = 'Snacks/Sides';

  return (
    <>
      <Divider />
      <Box sx={styles.container}>
        <Typography variant="body2" color="text.secondary">
          <Typography component="span" variant="body2" fontWeight="bold">
            {entreesSelected}/{entreesTotal}
          </Typography>{' '}
          {entreesLabel},{' '}
          <Typography component="span" variant="body2" fontWeight="bold">
            {snacksSelected}/{snacksTotal}
          </Typography>{' '}
          {snacksLabel}
        </Typography>

        <Button
          variant="contained"
          onClick={handleReviewSelection}
          size="large"
        >
          Review Selection
        </Button>
      </Box>
    </>
  );
};

export default ChooseMealsFooter;
